import React from "react";
import { IonButton } from "@ionic/react";
import { ErrorRefs } from "../ErrorRefs";

const Error: React.FC<{
  error: string | null;
  renderButton?: boolean;
  buttonText?: string;
  onButtonClick?: Function;
}> = ({
  error,
  renderButton = true,
  buttonText = "Retry",
  onButtonClick = null,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h6>Error Code: {error ? error : ErrorRefs["Unknown error"]}</h6>
      {renderButton && (
        <IonButton
          color="primary"
          style={{ fontFamily: "FredokaOne-Regular" }}
          onClick={() => onButtonClick && onButtonClick()}
        >
          {buttonText}
        </IonButton>
      )}
    </div>
  );
};

export default Error;
